import { createSlice } from "@reduxjs/toolkit";

import { GetProductReviews } from "../../reduxApi/website/ProductReview";
import { getMakeDataAPi, getModelDataAPi, getProductDataAPi, getYearDataAPi } from "../../reduxApi/website/MakeYearModel";

const MakeYearModelSlice = createSlice({
  name: "MakeYearModel",
  initialState: {
    status: "idle",

    getYearData: [],

    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getYearDataAPi.fulfilled, (state, action) => {
      state.status = "fulfilled";
      state.getYearData = action.payload;
      state.yearLoading = false;
      // console.log("Year data  Response:", state.getYearData);
    });
    // builder.addCase(getMakeDataAPi.fulfilled, (state, action) => {
    //   state.status = "fulfilled";
    //   state.getMakeData = action.payload;
    //   console.log("Year data  Response:", state.getYearData);
    // });
    // builder.addCase(getModelDataAPi.fulfilled, (state, action) => {
    //   state.status = "fulfilled";
    //   state.getModelData = action.payload;
    //   console.log("Year data  Response:", state.getYearData);
    // });
    // builder.addCase(getProductDataAPi.fulfilled, (state, action) => {
    //   state.status = "fulfilled";
    //   state.partTypeData = action.payload;
    // //   console.log("Year data  Response:", state.getYearData);
    // });
  },
});

export default MakeYearModelSlice.reducer;
